import { z } from "zod";
import { Role } from "../../shared/constants/roles.js";

export const REQUESTABLE_ROLES = [Role.Developer, Role.Analyst, Role.Operator] as const;

export const RequestableRoleSchema = z.enum(REQUESTABLE_ROLES);
export type RequestableRole = z.infer<typeof RequestableRoleSchema>;

export const RequestTempAccessSchema = z
  .object({
    orgId: z.string().min(1),
    role: RequestableRoleSchema,
    reason: z.string().trim().min(3).max(500),
  })
  .strict();

export type RequestTempAccessBody = z.infer<typeof RequestTempAccessSchema>;
